import { graphql, useStaticQuery } from "gatsby"
import React from "react"
import Listing3DTourCard from "@organic-return/foundation-react/src/components/Listing/Listing3DTourCard"

const VirtualTours = (props: any) => {
    
    const {listings} = props

    return (
        <div className="virtual-tours-module w-full max-w-screen-xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-y-8">
            {listings?.[0] && listings.map((listing: any, index: number) => (
                <Listing3DTourCard
                    key={index}
                    listing={listing}
                    linkText="VIEW COMPLETE LISTING"
                />
            ))}
        </div>
    )
}

export default VirtualTours

export const query = graphql`
fragment DrupalVirtualToursContent on DrupalVirtualTours {
    id
    listings {
        defaultImage {
            url
        }
        description
        tours {
            url
        }
        path
        address {
            street1
        }   
    }
}
`